module.exports = __webpack_public_path__ + "media/img/frontend_application/notification/venue_owner/enquiry_unread-d14ae6109115e92d572dd055d2023f01.png";